import classNames from 'classnames'
import { motion } from 'framer-motion'
import { ReactNode, useMemo } from 'react'

import { useWindowDimensions } from '@apps-common/hooks/useWindowDimensions'
import { useMenuStore } from '@apps-common/stores/menuStore'

interface IProps {
  id?: string
  children: ReactNode
  classes?: string
  useMargin?: boolean
}

export const PageContentContainerInline: React.FC<IProps> = ({ id, children, classes, useMargin }) => {
  const { open } = useMenuStore()
  const { width, isMobile } = useWindowDimensions()

  const closedWidth = isMobile ? '0px' : '100px'

  const mlValue = useMemo(() => (open ? '220px' : closedWidth), [open, closedWidth])

  if (!width) return null

  return (
    <motion.div
      id={id}
      initial={false}
      animate={{
        left: mlValue,
        transition: { type: 'tween' }
      }}
      className={classNames(classes, useMargin && 'mx-[1rem] md:mx-[2.1rem]')}
    >
      {children}
    </motion.div>
  )
}
